import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";

const LearningPathProgress = ({
  learningPathProgress = 0,
  // completed = 0,
  // total = 10,
}) => {
  const progress = Math.max(0, Math.min(100, Number(learningPathProgress)));

  return (
      <Box
        sx={{
          background: "#263238",
          borderRadius: 3,
          padding: 3,
          color: "#fff",
          boxShadow: "0px 8px 25px rgba(0,0,0,0.1)",
          width : "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
      {/* Title & Icon */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, fontSize: "16px", textAlign: "left" }}
        >
          Learning Path Progress
        </Typography>
        <TrackChangesOutlinedIcon sx={{ color: "#fff", fontSize: "20px" }} />
      </Box>

      {/* Percentage */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: "32px",
          mb: "14px",
          textAlign: "left",
          lineHeight : 1,
        }}
      >
        {progress.toFixed(0)}%
      </Typography>

      {/* Progress bar */}
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height : 8,
          borderRadius: 5,
          backgroundColor: "#ffffff55",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#d0a5f8",
          },
        }}
      />
    </Box>
  );
};

export default LearningPathProgress;
